export const SET_TERMS_AND_CONDITIONS = "SET_TERMS_AND_CONDITIONS";